
import { Component, Vue } from 'vue-property-decorator'
import TicketGygl from '@/views/Ticket/indexGygl.vue'

@Component({
  name: 'AllOrderLists',
  components: {
    TicketGygl
  }
})
export default class extends Vue {}
